import React, { Component } from 'react';
import { MemoryRouter, Switch, Route, Redirect, withRouter } from "react-router-dom";
import { TabBar, Label } from 'app/components/Basics';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import GlobalFieldLine from './components/GlobalFieldLine/GlobalFieldLineComponent';
import { AdHocSurveyFormContext } from './AdHocSurveyContext'
import AdHocSurveyService from "../../services/adHocSurvey.service";
import PanelConfigService from "../../services/panelConfig.service";
import GetErrorMessage from '../../helpers/error-message'
import ExtractTemplateIdFromLogs from '../../helpers/extract-template-id';
import { ShowError, ShowSuccess } from "../../components/toast"
import NewAdHocSurvey from './models/AdHocSurveyModel';
import Modal from '../../components/Modal';
import MultiSelect from 'app/components/MultiSelect';
import cloneDeep from 'lodash/cloneDeep';
import TabQuestions from './components/TabQuestions/TabQuestionsComponent';
import TabQuotas from './components/TabQuotas/TabQuotasComponent';
import TabConfigurations from './components/TabConfigurations/TabConfigurationsComponent';
import isEqual from 'lodash/isEqual';
import ValidateAdHocSurvey from './AdHocSurveyValidation'
import { isValidQuestionCode, getQuestionCodeValidationError } from '../question/QuestionValidation';
import { adHocSurveyTypes, GetSurveyTypeName } from 'app/constants/adhoc-survey-types';
import GetValidFileName from '../../helpers/valid-filename';
import { CSVLink } from 'react-csv';
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';

const DEEP_COPY_PROJECT_SUFFIX_MAX_LENGTH = 6;

class AdHocSurveyForm extends Component {
    static contextType = GlobalStateContext;
    tabs = [];
    _adHocSurveyService = {};
    _adHocNqSchemaService = {};
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'questions',
            selectedAdHocSurvey: NewAdHocSurvey(),
            errors: [],            
            surveyTypeName: GetSurveyTypeName(this.props.surveyType),
            deepCopyError: '',
            panelName: '',
            showConfiguredCopyModal: false,
            configuredCopyFile: null,
            configuredCopyError: '',
            availableLanguages: [],
            selectedLanguages: []
        }

        this._adHocSurveyService = new AdHocSurveyService(this.props.surveyType);
    }

    componentDidMount() {
        PanelConfigService.getPanelConfig().then(response => {
            const languages = (response.data.languages || []).map(l => ({
                value: l.code,
                label: `${l.description} (${l.code})`
            }));
            this.setState({ panelName: response.data.panelName, availableLanguages: languages });
        }).catch(() => {});
    }

    getTabs() {
        return [
            { id: "questions", label: 'Questions', url: 'questions', disabled: false, error: false },
            { id: "quotas", label: 'Quotas', url: 'quotas', disabled: this.props.surveyType !== adHocSurveyTypes.FiveMinex, error: false },
            { id: "configurations", label: 'Configurations', url: 'configurations', disabled: this.props.surveyType !== adHocSurveyTypes.FiveMinex, error: false }
        ];
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedAdHocSurvey != null) {
            this.setState({
                selectedAdHocSurvey: nextProps.selectedAdHocSurvey,
                activeTab: "questions"
            });
        }

        if (!isEqual(this.props.selectedAdHocSurvey, nextProps.selectedAdHocSurvey)) {
            this.setState({ errors: [] });
        }
    }

    updateSelectedAdHocSurvey(newSelectedAdHocSurvey) {
        this.setState({ selectedAdHocSurvey: newSelectedAdHocSurvey })
    }

    addErrorMessage(field, message) {
        var errors = this.state.errors;
        errors.push({ field: field, errorMessage: message });
        this.setState({ errors: errors })
    }

    SaveAdHocSurvey(adHocSurvey) {        
        this.props.toggleUiBlock(true);
        if (adHocSurvey.id) {
            this._adHocSurveyService.updateAdHocSurvey(adHocSurvey)
                .then(_ => {
                    this.props.toggleUiBlock(false);
                    this.setState({ successMessage: 'The survey was saved successfully' });
                    this.props.getAdHocSurveyById(adHocSurvey.id);
                    this.props.refreshAdHocSurveys();
                })
                .catch(error => {
                    let errorMessage = GetErrorMessage(error);
                    console.log("errorMessage on catch");
                    console.log(errorMessage);
                    this.props.toggleUiBlock(false);
                    this.setState({ errorMessage: errorMessage });
                });
        }
        else {
            this._adHocSurveyService.createAdHocSurvey(adHocSurvey)
                .then(response => {
                    const newAdHocSurvey = response.data;                    
                    this.props.toggleUiBlock(false);
                    this.setState({ successMessage: 'The survey was created successfully' });
                    this.setState({ selectedAdHocSurvey: newAdHocSurvey });
                    this.props.getAdHocSurveyById(newAdHocSurvey.id);
                    this.props.refreshAdHocSurveys();
                })
                .catch(error => {
                    let errorMessage = GetErrorMessage(error);
                    console.log("errorMessage on catch");
                    console.log(errorMessage);
                    this.props.toggleUiBlock(false);
                    this.setState({ errorMessage: errorMessage });
                });
        }

    }

    deleteAdHocSurvey = event => {
        this.setState({ deleteQuestionModalText: `Are you sure you want to delete the survey with name '${this.state.selectedAdHocSurvey.name}'?` });
    }

    duplicateAdHocSurvey = event => {
        let cloned = cloneDeep(this.state.selectedAdHocSurvey);
        cloned.id = null;
        cloned.name = `${cloned.name}_copy`;
        cloned.netQuestSurveyId = null;
        cloned.startDate = null;
        cloned.endDate = null;
        cloned.sampleId = null;
        cloned.uploadedSchemaFileName = null;
        cloned.forceSchemaQuestionUpdate = false;
        cloned.questions.forEach(surveyQuestion => {
            surveyQuestion.id = null;
            surveyQuestion.questionConditionsDefinition.id = null;
            this.cleanClonedConditionIds(surveyQuestion.questionConditionsDefinition.conditions);
            surveyQuestion.answerOptionsConditionsDefinitions.forEach(conditionsDefinition => {
                conditionsDefinition.id = null;
                this.cleanClonedConditionIds(conditionsDefinition.conditions);
            });
        });
        this.props.updateSelectedAdHocSurvey(cloned);
    }

    cleanClonedConditionIds(conditions) {
        conditions.forEach(condition => {
            condition.id = null;
        });
    }

    confirmDelete() {
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const adHocSurveyId = this.state.selectedAdHocSurvey.id;
        this._adHocSurveyService.deleteAdHocSurvey(this.state.selectedAdHocSurvey)
            .then(response => {
                this.setState({ successMessage: 'The survey was deleted successfully' });
                this.props.removeDeletedAdHocSurvey(adHocSurveyId);
                setTimeout(() => {
                    this.props.toggleUiBlock(false);
                    this.props.closeEditor();
                }, 2000);


            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage });
            });
    }

    hideDeleteModal() {
        this.setState({ deleteQuestionModalText: '' })
    }

    handleSubmitAction = event => {
        var validationErrors = ValidateAdHocSurvey(this.state.selectedAdHocSurvey);
        this.setState({ errors: validationErrors });
        if (validationErrors && validationErrors.length === 0) {
            this.SaveAdHocSurvey(this.state.selectedAdHocSurvey);
        }
        return;
    }

    createTestLinks() {
        this.props.toggleUiBlock(true);        
        this._adHocSurveyService.getAdHocSurveyTestLinks(this.state.selectedAdHocSurvey.id).then(response => {
            this.props.toggleUiBlock(false);
            let modalContent = response.data.testLinks.map((url, index) => (<div>Respondent {index + 1} - <a rel="noreferrer" href={url} target="_blank">{url}</a></div>));
            let linksToClipBoard = response.data.testLinks.map(url => `${url} \n`).join('');
            let logsToDownload = response.data.logs.map(log => `${log} \n`).join('');
            var templateId = "";
            if (this.state.selectedAdHocSurvey.netQuestSurveyId) {
                templateId = this.state.selectedAdHocSurvey.netQuestSurveyId;
            }
            else {
                templateId = ExtractTemplateIdFromLogs(response.data.logs);
            }
            // modalContent.unshift(<CSVDownloader filename={`testlinks_${this.state.surveyTypeName}_set_${GetValidFileName(this.state.selectedAdHocSurvey.name)}.csv`} data={linksToClipBoard} target="_blank" />)
            modalContent.unshift((<div><strong>Test links using TemplateId <span className='orange'>{templateId}</span> for set "<span className='orange'>{this.state.selectedAdHocSurvey.name}</span>":</strong></div>));
            modalContent.push((<CSVLink filename={`testlinks_${this.state.surveyTypeName}_set_${GetValidFileName(this.state.selectedAdHocSurvey.name)}.csv`} data={linksToClipBoard}>Download Links</CSVLink>))
            modalContent.push(<div></div>);
		    if (this.state.selectedAdHocSurvey.netQuestSurveyId) {
                modalContent.push((<div>No Logs Available to be Downloaded</div>))
            }
            else {
                modalContent.push((<CSVLink filename={`logs_for_testlinks_${this.state.surveyTypeName}_set_${GetValidFileName(this.state.selectedAdHocSurvey.name)}.csv`} data={logsToDownload}>Download Logs</CSVLink>));
            }
            this.setState({
                testLinksModalContent: modalContent,
                linksToClipBoard: linksToClipBoard
            });
        })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage });
            });
    }

    hideTestLinksModal() {
        this.setState({
            testLinksModalContent: '',
            linksToClipBoard: ''
        });
    }

    copyLinksToClipboard() {
        navigator.clipboard.writeText(this.state.linksToClipBoard);
    }

    archiveAdHocSurvey = event => {
        var adhocSurveyId = this.state.selectedAdHocSurvey.id;
        var newArhiveValue = this.state.selectedAdHocSurvey.inArchive === 1 ? 0 : 1;        
        this._adHocSurveyService.ArchiveAdHocSurvey(adhocSurveyId, newArhiveValue)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    var msg = newArhiveValue === 1 ? "archived" : "unarchived";
                    this.setState({ successMessage: `The survey was ${msg} successfully` });
                    this.props.getAdHocSurveyById(adhocSurveyId);
                    this.props.refreshAdHocSurveys();
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
    }

    deepCopyAdHocSurvey = event => {
        this.setState({ showDeepCopyModal: true, deepCopyProjectName: '' });
    }

    hideDeepCopyModal() {
        this.setState({ showDeepCopyModal: false, deepCopyProjectName: '', deepCopyError: '' });
    }

    handleDeepCopyProjectNameChange = event => {
        this.setState({ deepCopyProjectName: event.target.value, deepCopyError: '' });
    }

    confirmDeepCopy() {
        const projectName = this.state.deepCopyProjectName;
        if (!projectName || projectName.trim() === '') {
            this.setState({ deepCopyError: 'Project name is required for deep copy' });
            return;
        }

        if (projectName.trim().length > DEEP_COPY_PROJECT_SUFFIX_MAX_LENGTH) {
            this.setState({ deepCopyError: `Project name cannot be longer than ${DEEP_COPY_PROJECT_SUFFIX_MAX_LENGTH} characters` });
            return;
        }

        // Validate project name using same pattern as question code
        if (!isValidQuestionCode(projectName.trim())) {
            this.setState({ deepCopyError: getQuestionCodeValidationError('Project name') });
            return;
        }

        this.hideDeepCopyModal();
        this.props.toggleUiBlock(true);

        this._adHocSurveyService.deepCopyAdHocSurvey(this.state.selectedAdHocSurvey.id, projectName.trim())
            .then(response => {
                const newAdHocSurvey = response.data;
                this.props.toggleUiBlock(false);
                this.setState({ successMessage: `The survey was deep copied successfully as '${newAdHocSurvey.name}'` });
                this.props.getAdHocSurveyById(newAdHocSurvey.id);
                this.props.refreshAdHocSurveys();
            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage });
            });
    }

    configuredCopyAdHocSurvey = () => {
        this.setState({ showConfiguredCopyModal: true, configuredCopyFile: null, configuredCopyError: '', selectedLanguages: [] });
    }

    hideConfiguredCopyModal() {
        this.setState({ showConfiguredCopyModal: false, configuredCopyFile: null, configuredCopyError: '' });
    }

    handleConfiguredCopyFileChange = event => {
        const file = event.target.files[0];
        this.setState({ configuredCopyFile: file, configuredCopyError: '' });
    }

    confirmConfiguredCopy() {
        const file = this.state.configuredCopyFile;
        if (!file) {
            this.setState({ configuredCopyError: 'Configuration file is required' });
            return;
        }

        if (!file.name.endsWith('.xlsx')) {
            this.setState({ configuredCopyError: 'Only .xlsx files are supported' });
            return;
        }

        if (this.state.selectedLanguages.length === 0) {
            this.setState({ configuredCopyError: 'At least one language must be selected' });
            return;
        }

        this.hideConfiguredCopyModal();

        const languageCodes = this.state.selectedLanguages.map(l => l.value);
        const surveyName = this.state.selectedAdHocSurvey.name;

        this._adHocSurveyService.configuredCopyAdHocSurvey(this.state.selectedAdHocSurvey.id, file, languageCodes)
            .then(response => {
                const { jobId, newSurveyId } = response.data;
                const { addConfiguredCopyJob } = this.context;
                addConfiguredCopyJob({ jobId, newSurveyId, surveyName });
            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                this.setState({ errorMessage: errorMessage });
            });
    }

    render() {

        this.tabs = this.getTabs(this.state.selectedAdHocSurvey);
        return (

            <div className="AppFormComponent adHocSurveyForm">
                <AdHocSurveyFormContext.Provider value={{
                    updateSelectedAdHocSurvey: this.updateSelectedAdHocSurvey.bind(this),
                    selectedAdHocSurvey: this.state.selectedAdHocSurvey
                }}>
                    <form ref={form => this.formEl = form} onSubmit={this.handleSubmitAction}>
                            <GlobalControlLine errors={this.state.errors}
                                handleSubmitAction={this.handleSubmitAction.bind(this)}
                                deleteAdHocSurvey={this.deleteAdHocSurvey.bind(this)}
                                duplicateAdHocSurvey={this.duplicateAdHocSurvey.bind(this)}
                                deepCopyAdHocSurvey={this.deepCopyAdHocSurvey.bind(this)}
                                configuredCopyAdHocSurvey={this.configuredCopyAdHocSurvey.bind(this)}
                                panelName={this.state.panelName}
                                closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
                                didSelectedAdHocSurveyChange={this.props.didSelectedAdHocSurveyChange}
                                createTestLinks={this.createTestLinks.bind(this)}
                                canChangeData={this.props.canChangeData}
                                archiveAdHocSurvey={this.archiveAdHocSurvey.bind(this)}
                            />

                        <div className="form-head">
                            <GlobalFieldLine canChangeData={this.props.canChangeData}
                                folders={this.props.folders}
                                key={this.state.selectedAdHocSurvey.id}
                                metadata={this.props.metadata} />

                            {this.state.selectedAdHocSurvey.inArchive === 1 && (<div style={{ marginTop: '20px' }}><Label>This survey is archived!</Label></div>)}
                        </div>
                        <div className="form-sections">
                            <MemoryRouter>
                                <div className="tab-bar">
                                    <TabBar key="AdHocSurveyForm" activeTab={this.state.activeTab} tabs={this.tabs} onTabActivate={item => this.setState({ activeTab: item.id })} />
                                    {/* <div title="Load the current tab settings from another question." className="duplicate-tab"><ButtonIcon icon={DuplicateIcon}/></div> */}
                                </div>
                                <div className="section-content">
                                    <Switch>
                                        <Route exact path="/"><Redirect to={this.state.activeTab} /></Route>
                                        <Route exact path="/questions"><TabQuestions canChangeData={this.props.canChangeData} errors={this.state.errors} /></Route>
                                        <Route exact path="/quotas"><TabQuotas canChangeData={this.props.canChangeData} errors={this.state.errors} metadata={this.props.metadata}/></Route>
                                        <Route exact path="/configurations"><TabConfigurations canChangeData={this.props.canChangeData} errors={this.state.errors} /></Route>
                                    </Switch>
                                    <Redirect to={this.state.activeTab} />
                                </div>
                            </MemoryRouter>
                        </div>
                    </form>
                </AdHocSurveyFormContext.Provider>

                {this.state.errorMessage && (<ShowError clearErrorMessage={() => this.setState({ errorMessage: '' })} errorMessage={this.state.errorMessage} />)}
                {this.state.successMessage && (<ShowSuccess clearMessage={() => this.setState({ successMessage: '' })} message={this.state.successMessage} />)}
                {this.state.deleteQuestionModalText && (<Modal content={this.state.deleteQuestionModalText} size="small" confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}
                {this.state.testLinksModalContent && (<Modal hideConfirmButton content={this.state.testLinksModalContent} cancelButtonLabel="Close" confirmButtonLabel="Copy Test Links to Clipboard" cancelModalHandler={this.hideTestLinksModal.bind(this)} confirmModalHandler={this.copyLinksToClipboard.bind(this)} />)}
                {this.state.showDeepCopyModal && (
                    <Modal 
                        size="small" 
                        content={
                            <div>
                                <p><b>Enter a project prefix for the deep copy (6 characters max). This name will be used as:</b></p>
                                <ul style={{textAlign: 'left', marginBottom: '10px', marginLeft: '20px', paddingLeft: '20px'}}>
                                    <li>Prefix for the new survey name</li>
                                    <li>Suffix for the duplicated question codes</li>
                                    <li>Folder name for the survey and questions</li>
                                </ul>
                                <input 
                                    type="text" 
                                    placeholder="Project prefix for deep copy (required)" 
                                    value={this.state.deepCopyProjectName || ''} 
                                    onChange={this.handleDeepCopyProjectNameChange}
                                    style={{width: '100%', padding: '8px', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: '4px'}}
                                    maxLength={DEEP_COPY_PROJECT_SUFFIX_MAX_LENGTH}
                                    autoFocus
                                />
                                {this.state.deepCopyError && (
                                    <div style={{color: 'red', marginTop: '10px', fontSize: '14px'}}>
                                        {this.state.deepCopyError}
                                    </div>
                                )}
                            </div>
                        } 
                        confirmButtonLabel="Deep Copy"
                        disableConfirmButton={!this.state.deepCopyProjectName || this.state.deepCopyProjectName.trim() === ''}
                        confirmModalHandler={this.confirmDeepCopy.bind(this)} 
                        cancelModalHandler={this.hideDeepCopyModal.bind(this)} 
                    />
                )}
                {this.state.showConfiguredCopyModal && (
                    <Modal 
                        size="small" 
                        content={
                            <div>
                                <p><b>Configuration file (.xlsx)</b></p>
                                <input 
                                    type="file" 
                                    accept=".xlsx"
                                    onChange={this.handleConfiguredCopyFileChange}
                                    style={{width: '100%', padding: '8px', boxSizing: 'border-box'}}
                                />
                                <div style={{marginTop: '15px'}}>
                                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '5px'}}>Languages</label>
                                    <MultiSelect
                                        options={this.state.availableLanguages}
                                        selectedOptions={this.state.selectedLanguages}
                                        onChange={(items) => this.setState({ selectedLanguages: items })}
                                        onRemove={(item) => this.setState({ selectedLanguages: this.state.selectedLanguages.filter(l => l.value !== item.value) })}
                                        showSelectAll={true}
                                    />
                                </div>
                                {this.state.configuredCopyError && (
                                    <div style={{color: 'red', marginTop: '10px', fontSize: '14px'}}>
                                        {this.state.configuredCopyError}
                                    </div>
                                )}
                            </div>
                        } 
                        confirmButtonLabel="Copy"
                        disableConfirmButton={!this.state.configuredCopyFile || this.state.selectedLanguages.length === 0}
                        confirmModalHandler={this.confirmConfiguredCopy.bind(this)} 
                        cancelModalHandler={this.hideConfiguredCopyModal.bind(this)} 
                    />
                )}
            </div>
        );
    }
}
export default withRouter(AdHocSurveyForm); 